import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from 'reportWebVitals.js';

// import redux requirements
import { Provider } from 'react-redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import { store, persistedStore } from 'store.js';
import axios from 'axios';

// import html head tags requirements
import { Helmet } from 'react-helmet';
import { REACT_HELMET_PROPS } from 'config.js';

// import multi language
import LangProvider from 'lang/LangProvider';

// import routing modules
import { BrowserRouter as Router } from 'react-router-dom';
import RouteIdentifier from 'routing/components/RouteIdentifier';
import Loading from 'components/loading/Loading';

// import routes
import { getLayoutlessRoutes } from 'routing/helper';
import defaultRoutes from 'routing/default-routes';
import routesAndMenuItems from 'routes.js';

// import toastify for notification
import { Slide, ToastContainer } from 'react-toastify';

// mock server register for demo
import '@mock-api';

// Add a global axios request interceptor to inject the selected location
axios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const locationId = state.location?.selectedLocation?.id;
    if (locationId) {
      config.headers['x-location-id'] = locationId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global interceptor for native fetch() API
const originalFetch = window.fetch;
window.fetch = async function (...args) {
  let [resource, config] = args;

  const state = store.getState();
  const locationId = state.location?.selectedLocation?.id;

  if (locationId) {
    if (!config) {
      config = {};
    }

    // Safely parse headers if they exist
    if (config.headers instanceof Headers) {
      config.headers.append('x-location-id', locationId);
    } else {
      config.headers = {
        ...config.headers,
        'x-location-id': locationId
      };
    }
  }

  return originalFetch(resource, config);
};


const Main = () => {
  const layoutlessRoutes = useMemo(() => getLayoutlessRoutes({ data: routesAndMenuItems }), []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <Helmet {...REACT_HELMET_PROPS} />
        <ToastContainer transition={Slide} newestOnTop />
        <Router basename={process.env.REACT_APP_BASENAME}>
          <LangProvider>
            <RouteIdentifier routes={[...layoutlessRoutes, ...defaultRoutes]} fallback={<Loading />} />
          </LangProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
reportWebVitals();
